module.exports = __webpack_public_path__ + "static/media/records.51e77ebf.jpg";